import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import PropTypes from 'prop-types';
import GoogleClassroomList from 'core/modules/components/lists/google-classroom-list/GoogleClassroomList/GoogleClassroomList';
import React from 'react';
import SkeletonDialogGoogleClassroomImportUsers from './SkeletonDialogGoogleClassroomImportUsers';
import useDialogGoogleClassroomImportUsers from './useDialogGoogleClassroomImportUsers';

const DialogGoogleClassroomImportUsers = ({ open, onClose, onImportUsers }) => {
  const { t, loading, loadingClass, classrooms, selectedStudents, hasError, isEmpty, onChangeSelected, onChangeSelectedStudents, onSave } =
    useDialogGoogleClassroomImportUsers({
      open,
      onImportUsers,
    });

  return (
    <Dialog
      isOpen={open}
      hasSeparator={true}
      className={'dialog-google-clasroom-import-users'}
      buttonTextSuccess={t('actions:Import')}
      buttonTextCancel={t('actions:Cancel')}
      onClose={onClose}
      onSuccess={onSave}
      onCancel={onClose}
      isDisabledSuccess={selectedStudents.length === 0}
      title={t('classroom:Import users from Google Classroom')}
      size="xl"
      customFooterLeft={
        <div className="dialog-google-clasroom-import-users__number">{t('classroom:Selected X students', { count: selectedStudents.length })}</div>
      }
    >
      <div className="dialog-google-clasroom-import-users__container">
        {loading && <SkeletonDialogGoogleClassroomImportUsers />}
        {!loading && hasError && (
          <p className="dialog-google-clasroom-import-users__message" role="alert">
            {t('classroom:Could not load your classes from Google Classroom')}
          </p>
        )}
        {!loading && isEmpty && (
          <output className="dialog-google-clasroom-import-users__message">{t('classroom:You have no classes in Google Classroom')}</output>
        )}
        {!loading && !hasError && !isEmpty && (
          <GoogleClassroomList
            t={t}
            loadingClass={loadingClass}
            classes={classrooms}
            onChangeSelected={onChangeSelected}
            onChangeSelectedStudents={onChangeSelectedStudents}
          />
        )}
      </div>
    </Dialog>
  );
};

DialogGoogleClassroomImportUsers.propTypes = {
  onClose: PropTypes.func,
  onImportUsers: PropTypes.func,
  open: PropTypes.bool,
};

DialogGoogleClassroomImportUsers.defaultProps = {
  onClose: function () {},
  onImportUsers: function () {},
  open: false,
};

export default DialogGoogleClassroomImportUsers;
